import React from 'react';
import styles from './ErrorMessage.module.scss';

const ErrorMessage = ({ errorMessage = '', style = {} }) => {
  return (
    !!errorMessage && (
      <div style={style} className={styles.errorMessage}>
        {errorMessage}
      </div>
    )
  );
};

export default ErrorMessage;
